import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import HeaderFa from "../header-fa";
import FooterFa from "../footer-fa";
import productImage from "../../../assets/panel-scobo-fa.png";

function ScreeningTicketFa(props) {
  const [sendMessage, setSendMessage] = useState(
    "Hello,I'mInAutismScreeningTicketPageFa"
  );

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  return (
    <div className="container-v1">
      <HeaderFa />
      <div className="product">
        <div className="product-container">
          <div className="product-wrapper-right">
            <img src={productImage}></img>
          </div>
          <div className="product-wrapper-left">
            <div className="product-wrapper-left-header">
              <h1 className="screening-ticket-h11-font">
                {"دقیق‌ترین غربالگری اتیسم"}
              </h1>
              <h1 className="screening-ticket-h12-font">
                {"با کمک هوش مصنوعی"}
              </h1>
            </div>
            <div className="product-wrapper-left-content">
              <p>
                {
                  "تست غربالگری هوشمند اسکوبو به شما این امکان را می‌دهد تا با بهره‌گیری از دقت بالای هوش مصنوعی در تحلیل پاسخ‌ها، امکان وجود اتیسم در کودک خود را بررسی و در صورت نیاز، به متخصص مراجعه کنید"
                }
              </p>
            </div>
            <div className="product-wrapper-left-price align-items-end">
              <p>{"قیمت محصول:"}</p>
              <div className="d-flex flex-column align-items-center">
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۱۰۰٫۰۰۰ تومان"}
                </p>
                <p className="mt-0">{"رایگان"}</p>
              </div>
            </div>
            <div className="product-wrapper-left-button">
              <a href="/fa/signup" className="cta-btn w-100 mode-bg-2">
                {"شروع"}
              </a>
            </div>
          </div>
        </div>
      </div>
      <FooterFa />
    </div>
  );
}

export default ScreeningTicketFa;
